export default __webpack_public_path__ + "static/media/JPY.5d093c9b.svg";